export const footer = {
    namespaced: true,
    state:{
        displayFooter: false,
    },
    getters:{
        displayFooter(state) {
            return state.displayFooter;
        },
    },
    mutations:{
        showFooter(state){
            state.displayFooter = true;
        },
        hideFooter(state){
            state.displayFooter = false;
        },
    },
    actions:{

    }
};